import React, { useEffect } from "react";

// Using props with RouteComponentProps pattern for v5
const ReferralHandler = (props) => {

  
  // Extract referral code from match params
  const referralCode = props.match.params.referralCode;
  
  useEffect(() => {
    // Save the referral code to local storage
    if (referralCode) {
      localStorage.setItem("referralCode", referralCode);
      console.log(`Referral code ${referralCode} saved to local storage`);
    }
    // Check if we are on localhost
    const isLocalhost = window.location.hostname === "localhost";
    if (isLocalhost) {
      // Redirect to localhost URL
      window.location = `http://localhost:3000/accounts/signup`;
      return;
    }
    
    // Redirect to accounts page
    window.location = "https://mploi.com/accounts/signup";
  }, [referralCode]);

  // Return null or a loading indicator while redirecting
  return <div>Redirecting...</div>;
};

export default ReferralHandler;